// 商品系统--分类管理api
import {ServerNoDistApi} from '@/group-cloud/network/ServerBizApi';

export class CommodityMainApi {

    constructor() {
    }
    protected static groupUrl = '/main/account/configuration';

    //获取主体账户列表
    public static async getMainList(data) {
        let uri = this.groupUrl + '/list';
        return await ServerNoDistApi.send(uri, data);
    }

    //添加主体账户
    public static async saveAddMain(data) {
        let uri = this.groupUrl + '/saveAdd';
        return await ServerNoDistApi.send(uri, data);
    }

    //显示主体账户
    public static async showEditMain(data) {
        let uri = this.groupUrl + '/edit';
        return await ServerNoDistApi.get(uri, data);
    }

    //修改主体账户
    public static async saveEditMain(data) {
        let uri = this.groupUrl + '/saveEdit';
        return await ServerNoDistApi.send(uri, data);
    }

    //删除主体账户
    public static async deleteMain(data) {
        let uri = this.groupUrl + '/delete';
        return await ServerNoDistApi.get(uri, data);
    }

    //获取大区省份分类
    public static async getAreaValue(data) {
        let uri = this.groupUrl + '/areaValue';
        return await ServerNoDistApi.get(uri, data);
    }

    public static async getCityValue(data) {
        let uri = this.groupUrl + '/provinceToCity';
        return await ServerNoDistApi.send(uri, data);
    }


    //获取客户列表
    public static async getClientList(data) {
        let uri = this.groupUrl + '/clientList';
        return await ServerNoDistApi.send(uri, data);
    }

    //获取门店列表
    public static async getStoreList(data) {
        let uri = this.groupUrl + '/storeList';
        return await ServerNoDistApi.send(uri, data);
    }

    //获取批量商品列表
    public static async getResetsList(data) {
        let uri = this.groupUrl + '/resetList';
        return await ServerNoDistApi.send(uri, data);
    }

    //获取批量重置商品一级分类
    public static async getGoodsFirstType(data) {
        let uri = this.groupUrl + '/first';
        return await ServerNoDistApi.get(uri, data);
    }

    //获取批量重置商品二级以下分类
    public static async getGoodsOrderType(data) {
        let uri = this.groupUrl + '/subtype';
        return await ServerNoDistApi.get(uri, data);
    }

    //批量重置主体
    public static async saveResetsBody(data) {
        let uri = this.groupUrl + '/resetBody';
        return await ServerNoDistApi.send(uri, data);
    }

}


